export default "__VITE_ASSET__DcDcVkKn__"